import { useState } from 'react'
import { Box, Typography, Grid, Divider } from '@mui/material'

import { TableLimit } from '@/@core/components/mui/TableLimit'
import { useRouteQuery, useTranslator } from '@/hooks'
import { FilterButton } from '@/components/common'
import { SearchInput } from '@/components/common/SearchInput'
import InputDateRangerField from '@/components/common/input/InputDateRangerField'
import { SelectColumns } from '@/components/common/SelectColumns'
import BalanceTransactionStatusSelection from '@/components/selection/BalanceTransactionStatusSelection'

interface ColumnOption {
  key: string
  label: string
}

export const BalanceDetailFilterPast = ({
  onSelectColumns,
  columns,
  visibleColumns
}: {
  onSelectColumns?: (columns: string[]) => void
  columns?: ColumnOption[]
  visibleColumns?: string[]
}) => {
  const { __ } = useTranslator()
  const { updateQuery, searchQuery } = useRouteQuery()
  const [filter, setFilter] = useState(true)

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '20px',
        gap: 4,
        flexDirection: 'column'
      }}
    >
      {filter && (
        <>
          <Box className='mb-3'>
            <Typography variant='h6' className='mb-3'>
              {__('Filters')}
            </Typography>
            <Grid container spacing={2}>
              <Grid size={6}>
                <InputDateRangerField
                  value={
                    searchQuery.get('approve_at_from')
                      ? [searchQuery.get('approve_at_from') as string, searchQuery.get('approve_at_to') as string]
                      : []
                  }
                  placeholder={[__('Start date contract'), __('End date contract')]}
                  onChange={contract_at => {
                    if (contract_at) {
                      updateQuery({ approve_at_from: contract_at[0], approve_at_to: contract_at[1], page: 1 })
                    } else {
                      updateQuery({ approve_at_from: undefined, approve_at_to: undefined, page: 1 })
                    }
                  }}
                />
              </Grid>
              <Grid size={6}>
                <BalanceTransactionStatusSelection
                  value={searchQuery.get('status') || ''}
                  onSelect={status => {
                    updateQuery({ status, page: 1 })
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />
        </>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TableLimit />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <SearchInput
            placeholder={__('Search User')}
            onSearch={value => {
              updateQuery({ creator: value, page: 1 })
            }}
          />

          <FilterButton filter={filter} onFilter={() => setFilter(!filter)} />
          <div>
            <SelectColumns
              options={
                columns?.map(column => {
                  const isChecked = visibleColumns?.includes(column.key) ?? true

                  return {
                    id: column.key,
                    label: column.label,
                    checked: isChecked
                  }
                }) || []
              }
              onChange={options => {
                const selectedColumns = options.filter(option => option.checked).map(option => option.id)

                onSelectColumns?.(selectedColumns)
              }}
              buttonText={__('Columns')}
              showTotalSelected={false}
            />
          </div>
        </Box>
      </Box>
    </Box>
  )
}
